
<span [class]="statusClasses()">{{status | titleText}}</span>